import './App.scss'
import './components/okulyonetim-admin/_globalAdmin.scss'

import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  from,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import {Col, Empty, Layout, notification, Row} from 'antd'
import { Content, Footer, Header } from 'antd/es/layout/layout'
import trTR from 'antd/es/locale/tr_TR'
import { AliasToken } from 'antd/es/theme/interface'
import Demands from 'components/demands/Demands'
import FooterComponent from 'components/footer/Footer'
import LoginRequired from 'components/login-required/LoginRequired'
import ClassBranchesDetailPage from 'components/okulyonetim-admin/pages/class-branches/class-branches-detail-page/ClassBranchesDetailPage'
import ClassLessonImportPage from 'components/okulyonetim-admin/pages/class-lessons/class-lesson-import-page/ClassLessonImportPage'
import ClassLessonsDetailPage from 'components/okulyonetim-admin/pages/class-lessons/class-lessons-detail-page/ClassLessonsDetailPage'
import ClassListProductsDetailPage from 'components/okulyonetim-admin/pages/class-list-products/class-list-products-detail-page/ClassListProductsDetailPage'
import ClassListProductImportPage from 'components/okulyonetim-admin/pages/class-list-products/class-list-products-import-page/ClassListProductsImportPage'
import ClassImportPage from 'components/okulyonetim-admin/pages/classes/class-import-page/ClassImportPage'
import ClassesDetailPage from 'components/okulyonetim-admin/pages/classes/classes-detail-page/ClassesDetailPage'
import OkulSepetleriDetailPage from 'components/okulyonetim-admin/pages/okul-sepetleri-page/okul-sepetleri-detail-page/OkulSepetleriDetailPage'
import OkulSubelerDetailPage from 'components/okulyonetim-admin/pages/okul-subeler-page/okul-subeler-detail-page/OkulSubelerDetailPage'
import SchoolBranchOfficerDetailPage from 'components/okulyonetim-admin/pages/school-branch-officer/school-branch-officer-detail-page/SchoolBranchOfficerDetailPage'
import ScrollUp from 'components/scroll-up/ScrollUp'
import Toolbar from 'components/toolbar/Toolbar'
import AppContext from 'context/AppContext'
import {
  OkulDocument,
  OkulQueryResult,
  RefreshTokenDocument,
  RefreshTokenMutationResult,
} from 'gql/GeneratedGraphqlTypes'
import introSpectionResult from 'gql/IntrospectionResults'
import { Okul } from 'gql/StaticTypes'
import ChangePasswordPage from 'pages/account-pages/change-password/ChangePasswordPage'
import MasterAccountPage from 'pages/account-pages/MasterAccountPage'
import MyAccountPage from 'pages/account-pages/my-account/MyAccountPage'
import OrdersPage from 'pages/account-pages/orders/OrdersPage'
import AuthPage from 'pages/auth/AuthPage'
import HomePage from 'pages/home/HomePage'
import ResetPasswordPage from 'pages/reset-password/ResetPasswordPage'
import SchoolClosePage from 'pages/school-close-page/SchoolClosePage'
import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Container } from 'reactstrap'
import tinycolor from 'tinycolor2'
import { DEFAULT_API_TOKEN, DEFAULT_PRIMARY_COLOR } from 'utils/const'
import { doesLoginSessionExist, getLoginSession, saveLoginSession } from 'utils/helpers'
import { clearLoginSession } from 'utils/helpers'
import { AuthState } from 'utils/types'

import OkulyonetimAddedToClass from './components/okulyonetim/okulyonetim-added-to-class/OkulyonetimAddedToClass'
import OkulyonetimFavorite from './components/okulyonetim/okulyonetim-favorite/OkulyonetimFavorite'
import OkulyonetimFooter from './components/okulyonetim/okulyonetim-footer/OkulyonetimFooter'
import OkulyonetimProductDetail from './components/okulyonetim/okulyonetim-product-detail/OkulyonetimProductDetail'
import OkulyonetimProductList from './components/okulyonetim/okulyonetim-product-list/OkulyonetimProductList'
import OkulyonetimToolbar from './components/okulyonetim/okulyonetim-toolbar/OkulyonetimToolbar'
import Search from './components/okulyonetim/search/Search'
import FooterAdmin from './components/okulyonetim-admin/footer/Footer'
import HeaderAdmin from './components/okulyonetim-admin/header/HeaderAdmin'
import OkulyonetimAdminToolbar from './components/okulyonetim-admin/okulyonetim-admin-toolbar/OkulyonetimAdminToolbar'
import CiroPage from './components/okulyonetim-admin/pages/ciro-page/CiroPage'
import ClassBranchesImport from './components/okulyonetim-admin/pages/class-branches/class-branches-import/ClassBranchesImport'
import ClassBranches from './components/okulyonetim-admin/pages/class-branches/ClassBranches'
import ClassLessons from './components/okulyonetim-admin/pages/class-lessons/ClassLessons'
import ClassListProducts from './components/okulyonetim-admin/pages/class-list-products/ClassListProducts'
import Classes from './components/okulyonetim-admin/pages/classes/Classes'
import Dashboard from './components/okulyonetim-admin/pages/dashboard/Dashboard'
import OkulSepetleriPage from './components/okulyonetim-admin/pages/okul-sepetleri-page/OkulSepetleriPage'
import OkulSiparisDetayPage from './components/okulyonetim-admin/pages/okul-siparis-detay-page/OkulSiparisDetayPage'
import OkulSiparisPage from './components/okulyonetim-admin/pages/okul-siparis-page/OkulSiparisPage'
import OkulSiparisSatiriDetayPage from './components/okulyonetim-admin/pages/okul-siparis-satiri-detay-page/OkulSiparisDetayPage'
import OkulSiparisSatiriPage from './components/okulyonetim-admin/pages/okul-siparis-satiri-page/OkulSiparisSatiriPage'
import OkulSubeleriPage from './components/okulyonetim-admin/pages/okul-subeler-page/OkulSubeleriPage'
import SchoolBranchOfficer from './components/okulyonetim-admin/pages/school-branch-officer/SchoolBranchOfficer'
import AddTeacher from './components/okulyonetim-admin/pages/teachers/add-teacher/AddTeacher'
import Teachers from './components/okulyonetim-admin/pages/teachers/Teachers'
import Sidebar from './components/okulyonetim-admin/sidebar/Sidebar'
import AddAddressPage from './pages/account-pages/addresses/AddAddressPage'
import AddressesPage from './pages/account-pages/addresses/AddressesPage'
import MailDeport from './pages/account-pages/mail-deport/MailDeport'
import OrderDetailCheckPage from './pages/account-pages/order-details/OrderDetailCheckPage'
import OrderDetailPage from './pages/account-pages/order-details/OrderDetailPage'
import BasketPage from './pages/basket-pages/BasketPage'
import ClassProductsPage from "./pages/class-products/ClassProductsPage";
import CrossProductDetailPage from './pages/cross-product-pages/CrossProductsDetailPage'
import CrossProductPage from './pages/cross-product-pages/CrossProductsPage'
import LogoutPage from "./pages/logout/LogoutPage";
import OkulyonetimAdminPage from './pages/okulyonetim-admin-pages/OkulyonetimAdminPage'
import OkulyonetimPage from './pages/okulyonetim-pages/OkulyonetimPage'
import ConfigProvider from './theme-config/ThemeConfig'

export const AppRoutes = {
  auth: 'uyelik',
  logout: 'cikis',
  account: {
    root: 'hesap',
    myAccountInformation: 'hesap-bilgilerim',
    addresses: 'adreslerim',
    addAddress: 'adres-ekle',
    updateAddress: 'adres-guncelle',
    orders: 'siparislerim',
    orderDetail: 'siparis-detay',
    orderDetailCheck: 'siparis-fatura',
    changePassword: 'sifre-degistir',
  },
  classProducts: 'sinif-urunleri',
  basket: 'sepet',
  crossproduct: 'kategori',
  crossproductdetail: 'urun',
  resetPassword: 'sifre-sifirlama',
  schoolClose: 'okul-kapali',
  classClose: 'sinif-kapali',
  unsubscribe: 'mail-abonelik-iptal',
  okulyonetim: {
    base: 'okulyonetim',
    foreignLanguageBoooks: 'yabanc-dil-kitaplar',
    turkishBoooks: 'turkce-kitaplar',
    readingBoooks: 'okuma-kitaplar',
    stationary: 'krtasiye',
    digitalProducts: 'dijital-urunler',
    favoriteProducts: 'favori-urunler',
    productDetail: 'detay',
    search: 'arama',
    addedToClass: 'hesabim',
    demands: 'taleplerim',
  },
  admin: {
    base: 'okulyonetimadmin',
    ciro: 'ciro',
    schoolOrder: 'okulsiparis',
    classBranchesImport: 'sinifkategorisisaktar',
    schoolOrderLine: 'okulsiparissatiri',
    schoolBasket: 'okulsepeti',
    schoolBranch: 'sube',
    schoolBranchOfficer: 'subeyetkilisi',
    classBranches: 'sinifkategorisi',
    classes: 'sinif',
    classLessons: 'sinifdersi',
    classListProducts: 'dersurunu',
    teachers: 'ogretmen',
    addTeacher: 'ogretmen-ekle',
  },
}

function App() {
  const [apolloClient, setApolloClient] = useState<ApolloClient<NormalizedCacheObject> | null>(null)
  const [apiToken, setApiToken] = useState<string>(DEFAULT_API_TOKEN) //Make this check expire date then decide to make it null or local storage token. perhaps with a function.
  const [authState, setAuthState] = useState<AuthState>(AuthState.LOGGED_OUT)
  const [slug, setSlug] = useState<string | null>(null)
  const [email, setEmail] = useState<string>('')
  const [ciro, setCiro] = useState<boolean | undefined>()
  const [siparisYetki, setSiparisYetki] = useState<boolean | undefined>()
  const [okul, setOkul] = useState<Okul | null>(null)
  const [globalNotification, setGlobalNotification] = useState<{
    type: 'success' | 'info' | 'warning' | 'error'
    message: string
    description?: string
  } | null>(null)

  const [sinif, setSinif] = useState<number>()
  const [isSmallScreen, setIsSmallScreen] = useState(false)
  const [drawerVisible, setDrawerVisible] = useState(false)
  const MOBILE_WIDTH = 768

  useEffect(() => {
    if (!okul?.genel_uyari) return

    const notificationKey = `genel_uyari_${okul.id}`

    if (sessionStorage.getItem(notificationKey)) return

    notification.warning({
      message: 'Genel Uyarı',
      description: <span dangerouslySetInnerHTML={{ __html: okul.genel_uyari.replace(/&lt;/g, '<').replace(/&gt;/g, '>') }} />,
      placement: 'topRight',
      duration: 6,
    })

    sessionStorage.setItem(notificationKey, 'true')
  }, [okul?.id, okul?.genel_uyari])
  
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= MOBILE_WIDTH)
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  useEffect(() => {
    if (process.env.REACT_APP_SLUG) {
      setSlug(process.env.REACT_APP_SLUG)
    } else {
      const subdomain = window.location.hostname.split('.')[0]
      setSlug(subdomain)
    }

    //We can set api token here, public or
    //local storage item, at the same time
    //we can set initial auth state here too.
    if (doesLoginSessionExist()) {
      setApiToken(getLoginSession()!!.token!!)
    } else if (process.env.REACT_APP_AUTH_HEADER) {
      setApiToken(process.env.REACT_APP_AUTH_HEADER)
    }
  }, [])

  useEffect(() => {
    if (apiToken && slug) {
      const refreshLoginSession = async (client: ApolloClient<NormalizedCacheObject>) => {
        const { data } = (await client!!.mutate({ mutation: RefreshTokenDocument })) as RefreshTokenMutationResult
        if (data && data.refreshToken && data.refreshToken.token) {
          saveLoginSession(data.refreshToken)
          setApiToken(data.refreshToken.token)
          setAuthState(AuthState.LOGGED_IN)
        }
      }

      const httpLink = createHttpLink({
        uri: `${process.env.REACT_APP_API_URL}/graphql`,
        headers: {
          Authorization: apiToken,
        },
      })

      const errorLink = onError(({ graphQLErrors, networkError }) => {
        const includesUnauthorizedException = graphQLErrors?.some(
          (err: any) => err.errorType === 'UnauthorizedException',
        )
        if (includesUnauthorizedException) {
          clearLoginSession()
          setApiToken(DEFAULT_API_TOKEN)
          setAuthState(AuthState.LOGGED_OUT)
        }
      })

      const newApolloClient = new ApolloClient({
        cache: new InMemoryCache(introSpectionResult),
        connectToDevTools: true,
        link: from([errorLink, httpLink]),
      })

      let validToken = true
      if (doesLoginSessionExist()) {
        const expireAt = getLoginSession()!!.expire_at!! * 1000
        const now = Date.now()
        if (expireAt > now) {
          validToken = true
        } else {
          validToken = false
        }
      }

      if (slug && !okul && validToken) {
        const getOkul = async () => {
          const { data } = (await newApolloClient.query({
            query: OkulDocument,
            variables: { slug },
          })) as OkulQueryResult
          if (data && data.okul) {
            setOkul(data.okul)
          }
        }
        getOkul()
      }
      setApolloClient(newApolloClient)

      if (doesLoginSessionExist()) {
        const expireAt = getLoginSession()!!.expire_at!! * 1000
        const now = Date.now()
        if (expireAt <= now) {
          refreshLoginSession(newApolloClient)
        } else {
          setAuthState(AuthState.LOGGED_IN)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiToken, slug])

  if (!apolloClient || !okul) {
    return null
  }

  const getRoutes = () => {
    return (
      <>
        <Routes>
          <Route index element={<HomePage okul={okul} />} />
          <Route path={AppRoutes.auth} element={<AuthPage />} />
          <Route path={AppRoutes.logout} element={<LogoutPage />} />
          <Route path={`${AppRoutes.unsubscribe}/:email`} element={<MailDeport />} />
          <Route path={AppRoutes.account.root} element={<MasterAccountPage />}>
            <Route path={AppRoutes.account.myAccountInformation} element={<MyAccountPage />} />

            <Route path={`${AppRoutes.account.orderDetail}/:siparisId`} element={<OrderDetailPage />} />
            <Route path={`${AppRoutes.account.orderDetailCheck}/:siparisId`} element={<OrderDetailCheckPage />} />
            <Route path={AppRoutes.account.orders} element={<OrdersPage />} />
            <Route path={AppRoutes.account.changePassword} element={<ChangePasswordPage />} />
            <Route path={AppRoutes.account.addresses} element={<AddressesPage />} />
            <Route path={AppRoutes.account.addAddress} element={<AddAddressPage />} />
          </Route>
          <Route path={AppRoutes.resetPassword} element={<ResetPasswordPage />} />
          <Route path={AppRoutes.basket} element={<BasketPage />} />
          <Route index element={<OkulyonetimAdminPage okul={okul} />} />
          <Route
            path={`${AppRoutes.crossproduct}/:kategoriId`}
            element={
              <LoginRequired>
                <CrossProductPage />
              </LoginRequired>
            }
          />
          <Route
            path={`${AppRoutes.crossproductdetail}/:urunId`}
            element={
              <LoginRequired>
                <CrossProductDetailPage />
              </LoginRequired>
            }
          />
          <Route
            path={`${AppRoutes.classProducts}/:classId`}
            element={
              <LoginRequired>
                <ClassProductsPage />
              </LoginRequired>
            }
          />
          <Route path={`${AppRoutes.schoolClose}`} element={<SchoolClosePage okul={okul} />} />
          <Route path={`${AppRoutes.classClose}/:classId`} element={<SchoolClosePage okul={okul} />} />
          <Route
            path={AppRoutes.admin.base}
            element={
              <LoginRequired>
                <OkulyonetimAdminToolbar okul={okul} />
              </LoginRequired>
            }
          >
            <Route path="" element={<Dashboard />} />
            <Route path={`${AppRoutes.admin.ciro}`} element={<CiroPage />} />
            <Route path={`${AppRoutes.admin.schoolOrder}`} element={<OkulSiparisPage />} />
            <Route path={`${AppRoutes.admin.classBranchesImport}`} element={<ClassBranchesImport />} />
            <Route path={`${AppRoutes.admin.schoolOrderLine}`} element={<OkulSiparisSatiriPage />} />
            <Route path={`${AppRoutes.admin.schoolOrder}/:siparisId`} element={<OkulSiparisDetayPage />} />
            <Route
              path={`${AppRoutes.admin.schoolOrderLine}/:siparisSatiriId`}
              element={<OkulSiparisSatiriDetayPage />}
            />
            <Route path={`${AppRoutes.admin.schoolBasket}`} element={<OkulSepetleriPage />} />
            <Route path={`${AppRoutes.admin.schoolBasket}/:sepetId`} element={<OkulSepetleriDetailPage />} />
            <Route path={`${AppRoutes.admin.schoolBranch}`} element={<OkulSubeleriPage />} />
            <Route path={`${AppRoutes.admin.schoolBranch}/:id`} element={<OkulSubelerDetailPage />} />
            <Route path={`${AppRoutes.admin.schoolBranch}/kampüs-ekle`} element={<OkulSubelerDetailPage />} />

            <Route path={`${AppRoutes.admin.schoolBranchOfficer}`} element={<SchoolBranchOfficer />} />
            <Route path={`${AppRoutes.admin.schoolBranchOfficer}/:id`} element={<SchoolBranchOfficerDetailPage />} />
            <Route
              path={`${AppRoutes.admin.schoolBranchOfficer}/yetkili-ekle`}
              element={<SchoolBranchOfficerDetailPage />}
            />
            <Route path={`${AppRoutes.admin.classBranches}`} element={<ClassBranches />} />
            <Route path={`${AppRoutes.admin.classBranches}/:id`} element={<ClassBranchesDetailPage />} />
            <Route path={`${AppRoutes.admin.classBranches}/sinif-sube-ekle`} element={<ClassBranchesDetailPage />} />
            <Route path={`${AppRoutes.admin.classes}`} element={<Classes />} />
            <Route path={`${AppRoutes.admin.classes}/sinif-ice-aktar`} element={<ClassImportPage />} />

            <Route path={`${AppRoutes.admin.classes}/:id`} element={<ClassesDetailPage />} />
            <Route path={`${AppRoutes.admin.classes}/sinif-ekle`} element={<ClassesDetailPage />} />

            <Route path={`${AppRoutes.admin.classLessons}`} element={<ClassLessons />} />
            <Route path={`${AppRoutes.admin.classLessons}/ice-aktar`} element={<ClassLessonImportPage />} />

            <Route path={`${AppRoutes.admin.classLessons}/:id`} element={<ClassLessonsDetailPage />} />
            <Route path={`${AppRoutes.admin.classLessons}/:sinif-dersi-ekle`} element={<ClassLessonsDetailPage />} />
            <Route path={`${AppRoutes.admin.classListProducts}`} element={<ClassListProducts />} />
            <Route path={`${AppRoutes.admin.classListProducts}/ice-aktar`} element={<ClassListProductImportPage />} />
            <Route path={`${AppRoutes.admin.addTeacher}`} element={<AddTeacher />} />
            <Route path={`${AppRoutes.admin.classListProducts}/:id`} element={<ClassListProductsDetailPage />} />

            <Route path={`${AppRoutes.admin.teachers}`} element={<Teachers />} />
            <Route path={`${AppRoutes.admin.teachers}/:id`} element={<AddTeacher />} />
          </Route>
          <Route path={`${AppRoutes.okulyonetim.base}/${AppRoutes.okulyonetim.demands}`} element={<Demands />} />
          <Route
            path={`${AppRoutes.okulyonetim.base}`}
            element={
              <LoginRequired>
                <OkulyonetimPage okul={okul} />
              </LoginRequired>
            }
          >
            <Route
              path={`${AppRoutes.okulyonetim.foreignLanguageBoooks}`}
              element={
                <LoginRequired>
                  <OkulyonetimProductList />
                </LoginRequired>
              }
            />
            <Route
              path={`${AppRoutes.okulyonetim.turkishBoooks}`}
              element={
                <LoginRequired>
                  <OkulyonetimProductList />
                </LoginRequired>
              }
            />
            <Route
              path={`${AppRoutes.okulyonetim.search}`}
              element={
                <LoginRequired>
                  <Search />
                </LoginRequired>
              }
            />
            <Route
              path={`${AppRoutes.okulyonetim.readingBoooks}`}
              element={
                <LoginRequired>
                  <OkulyonetimProductList />
                </LoginRequired>
              }
            />
            <Route
              path={`${AppRoutes.okulyonetim.stationary}`}
              element={
                <LoginRequired>
                  <OkulyonetimProductList />{' '}
                </LoginRequired>
              }
            />
            <Route
              path={`${AppRoutes.okulyonetim.digitalProducts}`}
              element={
                <LoginRequired>
                  <OkulyonetimProductList />
                </LoginRequired>
              }
            />
            <Route
              path={`${AppRoutes.okulyonetim.favoriteProducts}`}
              element={
                <LoginRequired>
                  <OkulyonetimFavorite />
                </LoginRequired>
              }
            />
            <Route
              path={`${AppRoutes.okulyonetim.productDetail}/:id`}
              element={
                <LoginRequired>
                  <OkulyonetimProductDetail />
                </LoginRequired>
              }
            />
            <Route
              path={`${AppRoutes.okulyonetim.addedToClass}`}
              element={
                <LoginRequired>
                  <OkulyonetimAddedToClass />
                </LoginRequired>
              }
            />
          </Route>
        </Routes>
      </>
    )
  }

  const getThemeToken = (): Partial<AliasToken> => {
    const colorPrimary = okul.renk1 ?? DEFAULT_PRIMARY_COLOR
    return {
      colorPrimary,
      colorLink: colorPrimary,
      colorLinkHover: tinycolor(colorPrimary).darken(10).toString(),
      colorLinkActive: tinycolor(colorPrimary).lighten(20).toString(),
      colorIcon: colorPrimary,
      colorIconHover: tinycolor(colorPrimary).darken(10).toString(),
      controlItemBgActiveHover: tinycolor(colorPrimary).lighten(20).toString(),
    }
  }

  const isOkulYonetimPath = window.location.pathname.includes('okulyonetim')
  const isOkulYonetimAdminPath = window.location.pathname.includes('okulyonetimadmin')

  return (
    <ApolloProvider client={apolloClient}>
      <ConfigProvider
        renk1={okul.renk1 || '#D8263E'}
        renk2={okul.renk2 || '#ccc'}
        theme={{ token: getThemeToken() }}
        locale={trTR}
        renderEmpty={() => <Empty imageStyle={{ display: 'none' }} />}
      >
        <AppContext.Provider
          value={{
            slug,
            authState,
            setAuthState,
            setToken: setApiToken,
            okul,
            token: apiToken,
            sinif,
            setSinif,
            globalNotification,
            setGlobalNotification,
            ciro,
            setEmail,
            email,
            setCiro,
            setSiparisYetki,
            siparisYetki,
          }}
        >
          <BrowserRouter basename="/v1/">
            <div className="app">
              {apiToken === DEFAULT_API_TOKEN ? (
                <Layout>
                  <Header className="app-header">
                    <Toolbar okul={okul} logo={okul.logo} />
                  </Header>
                  <Content className="app-content">{getRoutes()}</Content>
                  <Footer className="app-footer">
                    <FooterComponent okul={okul} />
                  </Footer>
                </Layout>
              ) : isOkulYonetimAdminPath ? (
                <Layout>
                  <div className="admin-app">
                    <Row className="admin-app-row" wrap={false}>
                      <Col
                        className="side-bar-col"
                        style={{
                          width: isSmallScreen ? 0 : 288,
                          minWidth: isSmallScreen ? 0 : 288,
                        }}
                      >
                        <Sidebar
                          logo={okul.logo}
                          drawerVisible={drawerVisible}
                          setDrawerVisible={setDrawerVisible}
                          isSmallScreen={isSmallScreen}
                          userData={null}
                        />
                      </Col>

                      <Col
                        span={24}
                        flex={'auto'}
                        style={{
                          marginLeft: isSmallScreen ? 0 : 288,
                          overflowY: 'auto',
                        }}
                      >
                        <Container tag="main">
                          <HeaderAdmin
                            userData={null}
                            drawerVisible={drawerVisible}
                            setDrawerVisible={setDrawerVisible}
                            isSmallScreen={isSmallScreen}
                            renk1={okul.renk1}
                            renk2={okul.renk2}
                          />
                          <div className="content-main">
                            <div className="content-main-div">
                              <Content className="okulyonetim">{getRoutes()}</Content>
                            </div>
                          </div>
                          <FooterAdmin />
                        </Container>
                      </Col>
                    </Row>
                  </div>
                </Layout>
              ) : isOkulYonetimPath ? (
                <Layout>
                  <Header className="app-header">
                    <OkulyonetimToolbar
                      logo={okul.logo}
                      isim={okul.isim}
                      renk1={okul.renk1}
                      renk2={okul.renk2}
                      yetkili_ad={okul.yetkili_ad}
                      yetkili_soyad={okul.yetkili_soyad}
                      yetkili_numara={okul.yetkili_numara}
                    />
                  </Header>
                  <Content className="okulyonetim">{getRoutes()}</Content>
                  {window.location.pathname.includes('sepet') ? null : (
                    <Footer className="app-footer">
                      <OkulyonetimFooter okul={okul} logo={okul.logo} renk1={okul.renk1} renk2={okul.renk2} />
                    </Footer>
                  )}
                </Layout>
              ) : (
                <Layout>
                  <Header className="app-header">
                    <Toolbar okul={okul} logo={okul.logo} />
                  </Header>
                  <Content className="app-content">{getRoutes()}</Content>
                  {window.location.pathname.includes('sepet') ? null : (
                    <Footer className="app-footer">
                      <FooterComponent okul={okul} />
                    </Footer>
                  )}
                </Layout>
              )}
              <ScrollUp />
            </div>
          </BrowserRouter>
        </AppContext.Provider>
      </ConfigProvider>
    </ApolloProvider>
  )
}

export default App
